import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Twitter = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path
      d="M10.8163 31c12.5792 0 19.4583-11.7971 19.4583-22.0272 0-.335-.006-.6686-.0193-1.0007 1.3353-1.0927 2.496-2.4564 3.4114-4.0088-1.2254.6165-2.544 1.0316-3.9274 1.2188 1.412-.9585 2.496-2.4746 3.0074-4.282-1.3214.8867-2.7847 1.5312-4.3427 1.8792-1.248-1.5048-3.0247-2.446-4.992-2.446-3.7767 0-6.8393 3.467-6.8393 7.7407 0 .6075.06 1.1984.1774 1.7652C11.066 9.5155 6.026 6.435 2.6529 1.7506c-.5873 1.1441-.926 2.473-.926 3.8911 0 2.686 1.2074 5.057 3.0434 6.4442-1.122-.0393-2.176-.388-3.0973-.9683-.001.0325-.001.0642-.001.0989 0 3.7493 2.3574 6.8796 5.4866 7.589a6.1013 6.1013 0 0 1-1.8033.2724c-.44 0-.8687-.049-1.2853-.1396.8706 3.076 3.3953 5.3144 6.3886 5.377-2.3407 2.0769-5.2893 3.3138-8.494 3.3138-.5513 0-1.096-.0355-1.6313-.1071 3.0267 2.196 6.6206 3.4775 10.4833 3.4775"
      fillRule="nonzero"
    />
  </SvgIcon>
);

export default Twitter;
